import { getLiveTagValue } from "@/features/datapoints/api/getLiveTagValue.ts"
import { getTagIntervals } from "@/features/datapoints/api/getTagIntervals.ts"
import type { DataPointIntervalRequest, TagPath } from "@/types/dataPointTypes.ts"

import { getGasDayRemaining } from "../../util/getGasDayRemaining.ts"
import { getGasDayStart } from "../../util/getGasDayStart.ts"

import type { DailyDisplayData } from "../../types/dailyDisplayTypes.ts"

export const getDailyData = async (): Promise<DailyDisplayData> => {
  const biogasFlareMeter: TagPath = {
    tag: "fit_8035105",
    historyProvider: "BCO_DATABASE",
    driver: "ignition-dhmgw0m3:default",
  }

  const biomethaneFlareMeter: TagPath = {
    tag: "fit_8035101",
    historyProvider: "BCO_DATABASE",
    driver: "ignition-dhmgw0m3:default",
  }

  // const plantUptime: TagPath = {
  //   tag: "bco/live/plant status",
  //   historyProvider: "CISDB",
  //   driver: "ignition-scadavm2024:default",
  // };

  const start = getGasDayStart("America/Chicago", 9)
  const end = new Date()
  const interval = Math.round((end.getTime() - start.getTime()) / 1000) + 1

  const averageRequest: DataPointIntervalRequest = {
    start,
    end,
    interval,
    aggMode: "Average",
  }

  // const totalRequest: DataPointIntervalRequest = {
  //   start,
  //   end,
  //   interval,
  //   aggMode: "Sum",
  // };

  const responses = await Promise.all([
    getLiveTagValue(
      "default/BCO/Live/850/Oneok Pipeline Meter/Gas to Pipeline Daily Total (MMBtu)",
    ),
    getTagIntervals(biogasFlareMeter, averageRequest),
    getTagIntervals(biomethaneFlareMeter, averageRequest),
    getLiveTagValue("default/BCO/Live/850/Oneok Pipeline Meter/Gas to Pipeline Flow (MSCFD)"),
    getLiveTagValue(
      "default/BCO/Live/850/Oneok Pipeline Meter/Gas to Pipeline Methane Content (CH4 pct)",
    ),
  ])

  const values: number[] = [
    responses[0],
    responses[1][0]?.value ?? 0,
    responses[2][0]?.value ?? 0,
    responses[3],
    responses[4],
  ]

  const gasToPipeline = values[0]
  const gasFlared = ((values[1] * interval) / 60000) * 0.6 + (values[2] * interval) / 60000

  const runTime = 0
  const remainingHours = getGasDayRemaining("America/Chicago", 9)

  const outletSCFM = values[3] / 1.44
  const projection =
    gasToPipeline + (remainingHours * 60 * (outletSCFM * (values[4] / 100) * 1.01)) / 1000

  return {
    gasToPipeline,
    gasFlared,
    runTime,
    remainingHours,
    projection,
  }
}
